import { useTranslation } from "react-i18next";
import { TextFieldAtom } from "../../../../components/atoms/atom";
import LoginStepHeader from "./LoginStepHeader";
import LoginSubmitButton from "./LoginSubmitButton";

function LoginEmailStep({
	email,
	emailError,
	isRequesting,
	onEmailChange,
	onSubmit,
}) {
	const { t } = useTranslation();

	return (
		<>
			<LoginStepHeader
				eyebrow={t("login.title").toUpperCase()}
				heading={t("login.welcome-heading")}
				subtext={t("login.otp-description")}
			/>

			<div className="login-field login-field--email">
				<TextFieldAtom
					id="login-email"
					className="login-input"
					label={t("login.email")}
					type="email"
					autoFocus
					placeholder={t("login.enter-email")}
					value={email}
					error={emailError || ""}
					onChange={(e) => onEmailChange(e.target.value)}
					onKeyDown={(e) => e.key === "Enter" && onSubmit()}
					disabled={isRequesting}
				/>
			</div>

			<LoginSubmitButton
				onClick={onSubmit}
				disabled={isRequesting}
				loading={isRequesting}
				labelKey="login.send-code"
			/>
		</>
	);
}

export default LoginEmailStep;
